<template>
  <div class="">
    <div class="head-title">架构设置</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>展示部门列表，员工列表，员工所在部门详情。</p>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="mMain">
      <nav class="navbar">
        <div class="nav-l">
          <div style="margin-bottom: 2.0rem">
            <el-button
              type="primary"
              icon="el-icon-refresh"
              :loading="updateLoading"
              @click="getRenew"
              >{{ loadingText }}</el-button
            >
          </div>
        </div>
      </nav>
      <div class="">
        <div class="back">
          <div class="body-left">
            <div class="left-nav">
              <el-input
                clearable
                placeholder="请输入部门名称搜索"
                prefix-icon="el-icon-search"
                v-model="input2"
                @change="getDepartmentList"
              >
                <el-button
                  slot="append"
                  type="primary"
                  @click="getDepartmentList"
                  >搜索</el-button
                >
              </el-input>
            </div>
            <div class="left-bottom">
              <el-tree
                :data="data"
                :props="defaultProps"
                @node-click="handleNodeClick"
              >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span
                    ><img width="18" height="16" :src="treeIcon" alt="" />
                    {{ node.label }}</span
                  >
                  <!-- <i class="el-icon-more" @click="showMenu($event)"></i>
                  <transition name="el-zoom-in-top">
                    <div class="menu">
                      <div class="menu-btn" @click="() => append(data)">
                        添加子部门
                      </div>
                      <div class="menu-btn" @click="() => amend(data)">
                        修改名称
                      </div>
                      <div class="menu-btn" @click="() => dele(data)">删除</div>
                    </div>
                  </transition> -->
                </span>
              </el-tree>
            </div>
          </div>
          <div class="body-right">
            <div class="right-nav">
              <div class="h2">
                <p>{{ tooken.account_name }} ({{ age.count }}人)</p>
              </div>
              <div class="right-top">
                <!-- <div class="botton">
                  <el-button size="small" @click="addsun">
                    设置所在部门
                  </el-button>
                </div> -->
                <div class="right-body">
                  <div class="right-body-none">
                    <el-table
                      :data="tableData.data"
                      highlight-current-row
                      @current-change="handleSelectionChange"
                      border
                      :height="height"
                      v-loading="tableLoading"
                    >
                      <el-table-column
                        prop="avatar"
                        label="成员头像"
                        style="width: 10%"
                        align="center"
                      >
                        <template slot-scope="scope">
                          <img
                            :src="scope.row.avatar"
                            alt=""
                            style="width: 3.0rem; height: 3.0rem"
                          />
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="name"
                        label="成员名称"
                        style="width: 10%"
                        align="center"
                      ></el-table-column>

                      <el-table-column
                        prop="department_name"
                        label="部门"
                        style="width: 10%"
                        align="center"
                      ></el-table-column>
                      <el-table-column
                        prop="customer_count"
                        label="客户数"
                        style="width: 50%"
                        align="center"
                      ></el-table-column>
                      <!-- <el-table-column
                        fixed="right"
                        label="操作"
                        width="120"
                        align="center"
                      >
                        <template slot-scope="scope">
                          <el-button
                            size="mini"
                            @click="dekete(scope.row)"
                            type="danger"
                          >
                            离职
                          </el-button>
                        </template>
                      </el-table-column> -->
                    </el-table>
                  </div>
                </div>
                <div class="paging">
                  <pagination
                    :total="tableData.total"
                    :page.sync="listQuery.page"
                    :limit.sync="listQuery.limit"
                    :page-sizes="[10,20,50,100]"
                    :auto-scroll="false"
                    @pagination="userTable"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="添加" center :visible.sync="onSubmitsc" width="30%">
      <el-form ref="forms" :model="forms" label-width="10.0rem">
        <el-form-item label="部门名称">
          <el-input clearable v-model="forms.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmitsc = false">取 消</el-button>
        <el-button type="primary" @click="submitForm()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改" center :visible.sync="onSubmitscs" width="30%">
      <el-form label-width="10.0rem">
        <el-form-item label="修改部门名称">
          <el-input clearable v-model="amends.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmitscs = false">取 消</el-button>
        <el-button type="primary" @click="editDepartment()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="设置所在部门" center :visible.sync="onSubmitscss" width="30%">
      <div class="addshez">
        <div class="add-left">
          <div class="left-nav">
            <el-input
              clearable
              placeholder="请输入关键词"
              prefix-icon="el-icon-search"
              v-model="input2"
              style="width: 83%; margin-right: 2.0rem"
            >
            </el-input>
            <el-button type="primary" @click="getDepartmentList"
              >搜索</el-button
            >
          </div>
          <el-tree
            :data="datadst"
            show-checkbox
            default-expand-all
            node-key="id"
            ref="tree"
            highlight-current
            :props="defaultProps"
            :default-checked-keys="addbb"
          ></el-tree>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmitscss = false">取 消</el-button>
        <el-button type="primary" @click="setDepartment()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import Pagination from "@/components/Pagination";
export default {
  name: "mine",
  components: {
    Pagination,
  },
  data() {
    return {
      treeIcon: require("@/assets/wenjianjia@2x.png"),
      closeMenu: false,
      tooken: [],
      data: [],
      datadst: [],
      tableData: {
        total: 0,
        data: [],
      },
      forms: {
        name: "",
      },
      defaultProps: {
        children: "children",
        label: "name",
      },
      input2: "",
      onSubmitsc: false,
      onSubmitscs: false,
      onSubmitscss: false,
      appends: [],
      amends: [],
      pageSize: "",
      age: [],
      add: [],
      multipleSelection: "",
      select: "",
      addbb: [],
      department: "",
      listQuery: {
        page: 1,
        limit: 20,
      },
      height: 500,
      updateLoading: false,
      loadingText: "同步部门",
      tableLoading: true,
    };
  },
  mounted() {
    // 页面刷新就请求到数据渲染到页面中\
    // get请求页面的数据 http://192.168.0.149/api/Prive/getPriveList
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.getDepartmentList();
    this.updateDepartment();
    this.userTable();
    document.addEventListener("click", (e) => {
      this.menuHide();
    });
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    showMenu(event) {
      event.stopPropagation();
      this.menuHide();
      event.srcElement.nextElementSibling.style = "visibility: visible;";
    },
    menuHide() {
      let menus = Array.from(document.getElementsByClassName("menu"));
      menus.forEach((element) => {
        element.style = "visibility:hidden;";
      });
    },
    dekete(e) {
      this.$confirm("确定离职该员工吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/DepartmentSet/userDelete",
              qs.stringify({
                // 墨菲定律
                // 吧自己当回事
                // 贴标签
                // 第一印象
                userid: e.userid,
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              this.userTable();
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
            })
            .catch(function (err) {});
        })
        .catch(() => {
          this.$message({
            message: "取消删除",
            type: "success",
          });
        });
    },
    handleNodeClick(data) {
      console.log(data);
      this.menuHide();
      this.department = data.id;
      this.userTable();
    },
    addsun() {
      if (this.multipleSelection) {
        this.axios
          .post(
            "/crm/departmentSet/getUserDepartment",
            qs.stringify({
              usertoken: this.tooken.usertoken,
              account_id: this.tooken.account_id,
              userid: this.multipleSelection,
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            this.addbb = [];
            this.addbb = res.data.data.department;
          })
          .catch(function (err) {});
        this.onSubmitscss = true;
      } else {
        this.$message.error(res.data.msg);
        // this.$message.error("没有选择成员");
        return;
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val.userid;
    },
    setDepartment() {
      let nodeList = Array.from(new Set([...this.$refs.tree.getCheckedKeys()]));
      let a = nodeList.toString();
      this.axios
        .post(
          "/crm/departmentSet/setDepartment",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            userid: this.multipleSelection,
            id: a,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmitscss = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.userTable();
          } else if (res.data.code == 0) {
            this.onSubmitscss = true;
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {});
    },
    handleCurrentChange(val) {
      this.pageSize = val;
      this.userTable();
    },
    userTable() {
      this.axios
        .post(
          "/crm/Assistant/getAddressBook",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.name,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
            department: this.department,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.tableLoading = false;
          this.tableData = res.data.data;
          this.age = res.data;
          this.multipleSelection = "";
        })
        .catch(function (err) {});
    },
    editDepartment() {
      this.axios
        .post(
          "/crm/DepartmentSet/editDepartment",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            id: this.amends.id,
            name: this.amends.name,
            parentid: this.amends.parent_id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmitscs = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.updateDepartment();
          } else if (res.data.code == 0) {
            this.onSubmitscs = true;
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {});
    },
    updateDepartment() {
      this.axios
        .post(
          "/home/Wxwork/updateDepartment",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          //  3
          this.axios
            .post(
              "/home/Wxwork/updateDepartmentUser",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                phone: this.tooken.phone,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              this.getDepartmentList();
            })
            .catch(function (err) {});
        })
        .catch(function (err) {});
    },
    submitForm() {
      this.axios
        .post(
          "/crm/DepartmentSet/addDepartment",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            parentid: this.appends.id,
            name: this.forms.name,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmitsc = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.updateDepartment();
          } else if (res.data.code == 0) {
            this.onSubmitsc = true;
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {});
    },
    getDepartmentList() {
      this.axios
        .post(
          "/crm/DepartmentSet/getDepartmentList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            name: this.input2,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.data = res.data.data;
          this.datadst = res.data.data;
          // 使左侧选择部门与右边表格高度保持一致
          this.$nextTick(() => {
            this.height =
              document.querySelector(".body-left").offsetHeight - 40 - 52;
          });
        })
        .catch(function (err) {});
    },
    handleCheckChange(data, checked, indeterminate) {
      console.log(data, checked, indeterminate);
      if (checked) {
        for (var a = 0; a < data.length; a++) {}
      }
      if (!checked) {
        this.add.push(data);
      }
    },
    ppend(data) {
      const newChild = { id: id++, label: "testtest", children: [] };
      if (!data.children) {
        this.$set(data, "children", []);
      }
      data.children.push(newChild);
    },

    remove(node, data) {
      const parent = node.parent;
      const children = parent.data.children || parent.data;
      const index = children.findIndex((d) => d.id === data.id);
      children.splice(index, 1);
    },

    renderContent(h, { node, data, store }) {
      return (
        <span class="custom-tree-node">
          <span>{node.label}</span>
          <span>
            <el-button
              size="mini"
              type="text"
              on-click={() => this.append(data)}
            >
              添加
            </el-button>
            <el-button
              size="mini"
              type="text"
              on-click={() => this.amend(data)}
            >
              修改
            </el-button>
            <el-button size="mini" type="text" on-click={() => this.dele(data)}>
              删除
            </el-button>
          </span>
        </span>
      );
    },
    dele(data) {
      console.log(data);
      if (!data.children) {
        this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.axios
              .post(
                "/crm/DepartmentSet/delDepartment",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  id: data.id,
                }),
                {
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                  },
                }
              )
              .then((res) => {
                if (res.data.code == 1) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.updateDepartment();
                } else if (res.data.code == 0) {
                  this.$message.error(res.data.msg);
                }
              })
              .catch(function (err) {});
          })
          .catch(() => {
            this.$message({
              message: "取消删除",
              type: "success",
            });
          });
      } else {
        this.$message.error("不能删除父级");
        return;
      }
    },
    append(data) {
      this.onSubmitsc = true;
      this.appends = data;
    },
    amend(data) {
      this.onSubmitscs = true;
      this.amends = data;
      console.log(this.amends, 123213);
    },
    async getRenew() {
      this.updateLoading = true;
      // 拉取更新数据
      const ws = new WebSocket("wss://api.weijub.com:4431");
      ws.onopen = () => {
        console.log("连接成功");
        this.loadingText = "数据拉取中";
        ws.send(
          JSON.stringify({
            uid: this.tooken.account_id,
            type: "department",
          })
        );
      };
      ws.onmessage = (e) => {
        this.updateLoading = false;
        this.loadingText = "同步部门";
        this.$message.success("同步成功");
        this.tableData.data = [];
        this.userTable();
      };
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-table__body tr.current-row > td {
  background-color: rgb(185, 234, 250);
}
::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: rgb(185, 234, 250);
}
::v-deep .el-tree-node {
  position: relative;
}
::v-deep
  .el-table--striped
  .el-table__body
  tr.el-table__row--striped.current-row
  td {
  background-color: rgb(185, 234, 250);
}
.organiztion {
  width: 100%;
  height: 100%;
}
.body {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
}
.back {
  display: flex;
}
.body-left {
  width: 30%;
  height: 100%;
  padding: .0rem 2.0rem 2.0rem 2.0rem;
  height: 59.3rem;
  min-height: 59.3rem;
  border: .1rem solid #f2f3f5;
  position: relative;
  z-index: 10;
}
.body-right {
  width: 70%;
  height: 100%;
  padding: .0rem .0rem .0rem 1.2rem;
  border-top: .1rem solid #f2f3f5;
}
.left-nav {
  position: absolute;
  top: 1.2rem;
  display: flex;
  justify-content: center;
  width: 90%;
  border-bottom: .1rem solid #f2f3f5;
}
.left-bottom {
  width: 100%;
  height: 90%;
  display: inline-block;
  padding-top: 8.0rem;
}
.right-nav {
  width: 100%;
  height: 100%;
  // background-color: #f8f8f8;
  /* padding: 1.0rem; */
}
.right-nav > .h2 {
  padding-left: 1.0rem;
  display: flex;
  color: #272727;
  line-height: 4.0rem;

  font-size: 1.4rem;
}
.right-top {
  width: 100%;
  height: 90%;
  /* background-color: hotpink; */
}
.botton {
  width: 100%;
  background-color: #298edb;
  display: flex;
  padding: 1.0rem 0 1.0rem 1.0rem;
  align-items: center;
}
.right-body {
  width: 100%;
  height: 85%;
}
.right-body-none {
  width: 100%;
  height: 90%;
  overflow: hidden;
  overflow-y: auto;
}
::v-deep .el-tree-node__content {
  width: 100% !important;
}
// ::v-deep .el-tree-node__content:hover{
//   background-color: #1862A8 ;
// }
//
::v-deep .custom-tree-node {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1.4rem;
  padding-right: .8rem;
}

::v-deep .custom-tree-node {
  align-items: center;
}
::v-deep .el-button--text {
  font-size: 1.8rem;
}
.vanish {
  display: none;
}
.appear {
  display: block;
  width: 15.0rem;
  background-color: #fff;
  position: relative;
  left: 15.0rem;
}
.addshez {
  width: 100%;
  height: 50.0rem;
  display: flex;
}
.add-left {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  // background-color: red;
}

.menu {
  position: absolute;
  visibility: hidden;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  z-index: 2;
  right: -15.2rem;
  top: 2.0rem;
  width: 15.6rem;
  color: #343434;
  background-color: #fff;
  border: .1rem solid #eeeeee;
  box-shadow: .0rem .0rem .8rem .0rem rgba(185, 192, 203, 0.2);
}
.menu .menu-btn {
  margin: .6rem 0;
  padding: .6rem 2.0rem;
  text-align: center;
}
.menu .menu-btn:hover {
  background-color: #1862a8;
  color: #fff;
}
.el-icon-more {
  transform: rotate(90deg);
  padding: 1.5rem .0rem;
}
::v-deep .el-tree-node > .el-tree-node__children {
  overflow: visible;
}
::v-deep .el-tree-node__content {
  position: relative;
}

::v-deep .el-table thead th {
  // background-color: #d4e9fd;
  color: #202020;
}
.fsize-15 {
  font-size: 1.5rem;
}

::-webkit-scrollbar-track-piece {
  -webkit-border-radius: 0;
}
::-webkit-scrollbar {
  width: .5rem;
  height: 1.0rem;
}
::-webkit-scrollbar-thumb {
  height: 5.0rem;
  background-color: #fff;
  -webkit-border-radius: .6rem;
  outline-offset: -.2rem;
  filter: alpha(opacity = 50);
  -moz-opacity: 0.5;
  -khtml-opacity: 0.5;
  opacity: 0.5;
}
::-webkit-scrollbar-thumb:hover {
  height: 5.0rem;
  background-color: #878987;
  -webkit-border-radius: .6rem;
}
.el-table{
  margin-top: .0rem !important;
}
</style>
